import { createAction } from '@reduxjs/toolkit';
export const SET_DEFAULT_CRM = 'SET_DEFAULT_CRM';
export const setDefaultCrmAction = createAction(SET_DEFAULT_CRM);